import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Row } from "react-bootstrap";
import { withStyles } from "@material-ui/core/styles";
import Rating from "@material-ui/lab/Rating";
import StarBorderIcon from "@material-ui/icons/StarBorder";

import "./productcard.scss";
import Logo from "../../../../assets/images/logo.png";

import { FaCheckCircle } from "react-icons/fa";
import { getDesktopImage } from "../../../../utils/utils";
require("dotenv").config();

const StyledRating = withStyles({
  iconFilled: {
    color: "#ffd700",
  },
  iconHover: {
    color: "#ffd700",
  },
  iconEmpty: {
    color: "#404553",
  },
})(Rating);

const ProductCard = (props) => {
  const product =
    props.type === "product"
      ? {
          id: props.product && props.product.id,
          badge: "Your Products",
          image: getDesktopImage(
            props.product?.variants[0]?.featured_image_resized,
            props.product?.variants[0]?.featured_image
          ),
          promo: "PROMOCODE",
          description:
            props.product &&
            props.product.variants &&
            props.product.variants.length > 0 &&
            props.product.variants[0].description_en,
          name: props.product && props.product.name_en,
          currency: props.vendorStore && props.vendorStore.currency,
          price:
            props.product &&
            props.product.variants &&
            props.product.variants.length > 0 &&
            props.product.variants[0].price,
          discounted_price:
            props.product &&
            props.product.variants &&
            props.product.variants.length > 0 &&
            props.product.variants[0].discounted_price,
          average_rating: props.product && props.product.average_rating,
          total_review: props.product && props.product.reviews.length,
          store_logo: props.product?.store_logo
            ? props.product.store_logo
            : Logo,
          verified: props.vendorStore && props.vendorStore.verified,
        }
      : {
          id: props.product && props.product.id,
          badge: "Your Products",
          image: getDesktopImage(
            props.product?.featured_image_resized,
            props.product?.featured_image
          ),
          promo: "PROMOCODE",
          description: props.product && props.product.description_en,
          name: props.product && props.product.name_en,
          currency: props.vendorStore.currency,
          price: props.product && props.product.price,
          discounted_price: props.product && props.product.discounted_price,
          average_rating: props.product && props.product.average_rating,
          total_review: props.product && props.product.reviews.length,

          store_logo: props.product?.store_logo
            ? props.product.store_logo
            : Logo,
          verified: props.vendorStore && props.vendorStore.verified,
        };
  return (
    <Fragment>
      <a
        href={`${
          process.env.REACT_APP_STORE_DOMAIN
        }/${props.product.store_country_name_en.toLowerCase()}-en/${props.product.category_title_en
          ?.toLowerCase()
          .replace(/ /g, "-")}/${props.product.slug}`}
        style={{ textDecoration: "none", color: "unset" }}
      >
        <div className="product-card-container-desktop">
          <Row className="product-badge-row d-flex justify-content-between mx-auto"></Row>
          <Row className="product-image-row mx-auto">
            {product.image && (
              <img className="img mx-auto" src={product.image} alt="product" />
            )}
          </Row>
          <Row className="product-description-row mx-auto">
            <div className="product-description-container">
              <div className="product-description">{product.name}</div>
            </div>
            <div className="product-price-container d-flex flex-wrap align-items-center">
              <div className="price-after-discount">
                <span className="currency fw-700 me-1 text-uppercase">
                  {product.currency}
                </span>
                <span className="value">{product.discounted_price}</span>
              </div>
              {product.discounted_price < product.price && (
                <div className="price-before-discount text-uppercase">
                  <span className="currency text-uppercase">
                    {product.currency}
                  </span>
                  <span className="value">{product.price}</span>
                </div>
              )}
            </div>
          </Row>
          <Row className="product-rating-row mx-auto">
            <div className="product-rating-container d-flex align-items-center">
              <StyledRating
                name="customized-empty"
                defaultValue={0}
                precision={0.5}
                emptyIcon={<StarBorderIcon fontSize="inherit" />}
                size="small"
                readOnly
                value={parseInt(product.average_rating)}
              />
              <div className="product-rating-count ml-2">
                {product.total_review === null
                  ? ""
                  : `(${product.total_review})`}
              </div>
            </div>
          </Row>
          <Row className="seller-info-row mx-auto">
            <div className="seller-info-container d-flex align-items-center">
              <div className="seller-logo">
                {product.store_logo ? (
                  <img
                    src={product.store_logo}
                    alt="logo"
                    style={{
                      width: "auto",
                      maxWidth: "100%",
                      heigth: "100%",
                    }}
                  />
                ) : (
                  props.vendorStore.name_en
                )}
              </div>
              <div className="seller-verified d-flex justify-content-center align-items-center">
                {product.verified && <FaCheckCircle />}
              </div>
            </div>
          </Row>
        </div>
      </a>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return { vendorStore: state.vendorStore.vendorStore };
};
export default connect(mapStateToProps, null)(ProductCard);
